module.exports = __webpack_public_path__ + "67074d0190d58c735a1b675f2001dbbf.svg";